import api from './api'
import type { DocumentExpirationAlertsResponse } from '@/types/documentNotification'

export const documentNotificationService = {
  /**
   * Get expiring and expired document alerts for the authenticated user.
   * Admin/Owner gets organization-wide alerts. Staff gets their own alerts.
   */
  async getExpiringDocuments(): Promise<DocumentExpirationAlertsResponse['data']> {
    const response = await api.get<DocumentExpirationAlertsResponse>(
      '/notifications/expiring-documents'
    )
    return response.data.data
  },
}

export default documentNotificationService

